import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../api/client";
import ENDPOINTS from "../../api/endpoints";
import { showNotification } from "../Notifications/notificationsSlice";

export const fetchRecordedContactsInsights = createAsyncThunk(
  "insights/fetchRecordedContactsInsights",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();

      if (filters.recorded_contact_ids?.length) {
        filters.recorded_contact_ids.forEach((id) =>
          params.append("recorded_contact_ids", id)
        );
      }

      if (filters.function) params.set("function", filters.function);
      if (filters.route) params.set("route", filters.route);
      if (filters.area) params.set("area", filters.area);

      const url = `${
        ENDPOINTS.RECORDED_CONTACTS_INSIGHTS
      }?${params.toString()}`;

      const response = await apiClient.get(url);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
